import { useId } from 'react'

import { AstraParagraph } from '../../Typography/AstraParagraph/AstraParagraph'
import { getErrorTextId } from './AstraInputWrapper'

type Props = {
    errorText?: string
    error?: boolean
    id?: string
}

export const AstraErrorText = ({ errorText, error, id }: Props) => {
    const uniqueId = useId()
    const errorTextId = id ? getErrorTextId(id) : `error-text-${uniqueId}`

    if (!error || !errorText) return null

    return (
        <AstraParagraph id={errorTextId} aria-live="polite" variant="body-small" className="text-wrap text-critical">
            {errorText}
        </AstraParagraph>
    )
}
